import React from "react";

export default function Web_AngularJS() {
  return (
    <div>
      <h1>What is AngularJS</h1>
      <p>
        Route: <code>/web/angularjs</code>
      </p>
      <p>Auto-generated component.</p>
    </div>
  );
}
